module.exports = {"321323100":"众兴镇","321323101":"爱园镇","321323102":"王集镇","321323103":"裴圩镇","321323104":"新袁镇","321323105":"李口镇","321323106":"临河镇","321323107":"穿城镇","321323108":"张家圩镇","321323109":"高渡镇","321323110":"卢集镇","321323200":"庄圩乡","321323201":"里仁乡","321323202":"三庄乡","321323203":"南刘集乡","321323204":"八集乡","321323400":"棉花原种场","321323401":"泗阳农场","321323402":"江苏泗阳开发区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/321323.json
// module id = 938
// module chunks = 0